import React from 'react';
import IconProps from '../../icons';

const Spotify = ({ width = 24, color = 'var(--text-primary)', className = '' }: IconProps): JSX.Element => {
  return (
    <svg
      className={className}
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM16.4711 17.0409C16.8128 17.2361 17.2501 17.145 17.4552 16.8197C17.6602 16.4944 17.5508 16.078 17.2091 15.8828C14.2022 14.1262 10.4573 13.7228 6.09727 14.6727C5.71457 14.7507 5.48222 15.1151 5.56423 15.4794C5.64624 15.8438 6.02893 16.065 6.41163 15.9869C10.4026 15.1281 13.7785 15.4794 16.4711 17.0409ZM17.6192 14.1392C18.0429 14.3734 18.5896 14.2563 18.8493 13.8529C19.1089 13.4495 18.9723 12.929 18.5759 12.6948C15.036 10.6259 9.86956 10.0534 5.71457 11.2505C5.2362 11.3806 4.97652 11.849 5.11319 12.3045C5.24987 12.7469 5.74191 12.9941 6.22028 12.864C9.8559 11.81 14.5439 12.3305 17.6192 14.1392ZM5.67357 9.49383C9.19984 8.47889 15.282 8.67407 18.9723 10.756C19.478 11.0553 20.134 10.8861 20.421 10.3917C20.7217 9.91022 20.5577 9.28564 20.052 8.99937C15.815 6.60514 9.0905 6.37092 5.04486 7.54201C4.48448 7.71117 4.15645 8.2837 4.33413 8.8172C4.51182 9.36371 5.11319 9.66299 5.67357 9.49383Z'
        fill={color}
      />
    </svg>
  );
};

export default Spotify;
